
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/surgical-assistance",
      function () {
        return require("private-next-pages/services/surgical-assistance/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/surgical-assistance"])
      });
    }
  